import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { de, enUS, ja } from "date-fns/locale";
import type { Locale } from "date-fns";

/**
 * Returns the appropriate date-fns locale based on the current i18n language.
 * Supports German (de), English (en), and Japanese (ja).
 */
export function useDateLocale(): Locale {
  const { i18n } = useTranslation();

  return useMemo(() => {
    switch (i18n.language) {
      case "ja":
        return ja;
      case "en":
        return enUS;
      case "de":
      default:
        return de;
    }
  }, [i18n.language]);
}
